export default function BillingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Billing & Subscription</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">
            Billing integration will be completed in Option 5 (Stripe billing).
          </p>
        </div>
      </div>
    </div>
  );
}
